import { render, staticRenderFns } from "./FileSourceNameSpan.vue?vue&type=template&id=2491859e"
import script from "./FileSourceNameSpan.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileSourceNameSpan.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports